import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-s3batch',
  templateUrl: './s3batch.component.html',
  styleUrls: ['./s3batch.component.css']
})
export class S3batchComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData =`
  {
    "paths": [
      "Videos_for_Optimization/Show.MOV"
    ],
    "crunch_modes": [
      "video_optimizer"
    ],
    "process_type": "quality"
  }`





  sucessData =`
  {
    "data": null,
    "message": "Batch request submitted successfully"
  }
  `

  Error5x =`
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x =`
  {
    "error": "invalid character '}' after object key",
    "message": "Error parsing the input"
  }`

  Error42x =`
  {
    "error": "crunch_modes is the required field and cannot be empty",
    "message": "Crunch Modes cannot be empty"
  }`



  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `
  // Image

  requestImageData = `
  curl 'https://api.optimusdrive.ai/v1/s3/batch' \  -H 'authorization: XXXX'  \ --data-raw 
  '{
    "paths":["Main_folder/VideoImagesFolder_vietnam-6634082_640.jpg"],
    "crunch_modes":["image_optimizer"]
  }'   
  `


  imageClipboard(){
    this.ImageopyToClipBoard(this.requestImageData);
  }


  ImageopyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }





}
